export const GetMarketForm = "/Market/GetMarketForm";
export const GetMarketLoggedInForm = "/MarketLoggedIn/GetMarketLoggedInForm";

export const MarketFavorite = "/MarketLoggedIn/MarketFavorite";

export const GetMarketLoggedInList = (destSelected) =>
  `/MarketLoggedIn/GetMarketLoggedInList?CoinSourceId=-1&CoinDestinationId=${destSelected}`;

export const GetSingleMarketLoggedInList = ({
  CoinSourceId,
  CoinDestinationId,
}) =>
  `/MarketLoggedIn/GetMarketLoggedInList?CoinSourceId=${CoinSourceId}&CoinDestinationId=${CoinDestinationId}`;

export const GetMarketListImportantWithGOLD =
  "/Market/GetMarketListImportantWithGOLD";
